import React from "react";

export const Splash = React.lazy(() => import("./default/splash"));
export const Login = React.lazy(() => import("./auth/login"));
export const Signup = React.lazy(() => import("./auth/signup"));
export const OTPScreen = React.lazy(() => import("./auth/otp"));
export const ResetPasswordOTP = React.lazy(() => import("./auth/resetPasswordOTP"));
export const ForgotPasswordScreen = React.lazy(() => import("./auth/forgotPassword"));
export const ResetPasswordScreen = React.lazy(() => import("./auth/resetPassword"));
export const Dashboard = React.lazy(() => import("./dashboard/index"));
export const ShareWin = React.lazy(() => import("./shareWin/shareWin"));
export const Profile = React.lazy(() => import("./profile/profile"));
export const RefereWin = React.lazy(() => import("./refererWin/refereWin"));
export const MatchDetails = React.lazy(() => import("./matchDetails/index"));